import { combineReducers } from 'redux'
import { createActionThunk } from 'redux-thunk-actions'
import { handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'

import kyc from './kyc'
import passwords from './passwords'
import tokens from './tokens'
import referral_users from './referral_users'
import payments from './payments'
import deposits from './deposits'
import promocodes from './promocodes'
import promotokens from './promotokens'
import api from 'core/api'
import { signUpThunk } from '../sign_up'
import { signInThunk } from '../sessions'
import { prolong, setupSessionProlongation } from '../sessions/prolong'
import { signOutThunk } from '../sign_out'
import { enableThunk, disableThunk } from '../otp'

const getType = type => `@users/current/${type}`

export const getCurrentUserThunk = createActionThunk(getType('FETCH'), api('/users/current'))

export const getCurrentUser = props => dispatch =>
  dispatch(getCurrentUserThunk(props)).then(() => dispatch(setupSessionProlongation()))

export const updateCurrentUserThunk = createActionThunk(
  getType('UPDATE'),
  api('/users/current', { method: 'PUT' })
)

export const updateCurrentUser = props => dispatch =>
  dispatch(updateCurrentUserThunk(props)).then(() =>
    dispatch(toastr.add({ type: 'success', message: 'You have successfully updated your profile' }))
  )

const initialState = {}

const reducer = handleActions(
  {
    [getCurrentUserThunk.SUCCEEDED]: (state, { payload }) => ({ ...state, ...payload }),
    [updateCurrentUserThunk.SUCCEEDED]: (state, { payload }) => ({
      ...state,
      ...payload,
      error: null
    }),
    [updateCurrentUserThunk.FAILED]: (state, { payload }) => ({ ...state, ...payload }),
    [signInThunk.SUCCEEDED]: (state, { payload }) => payload,
    [prolong.SUCCEEDED]: (state, { payload }) => payload,
    [signUpThunk.SUCCEEDED]: (state, { payload }) => payload,
    [signOutThunk.ENDED]: state => initialState,
    [enableThunk.SUCCEEDED]: state => ({
      ...state,
      json: { ...state.json, otp_required_for_login: true }
    }),
    [disableThunk.SUCCEEDED]: state => ({
      ...state,
      json: { ...state.json, otp_required_for_login: false }
    })
  },
  initialState
)

export default combineReducers({
  index: reducer,
  kyc,
  passwords,
  tokens,
  referral_users,
  payments,
  deposits,
  promocodes,
  promotokens
})



// WEBPACK FOOTER //
// ./src/modules/users/current/index.js